import { callAuthorizedGraphQLEndpoint } from '../../../Module/graphQL'

const createCampaignDeliverabilityByCampaignId = campaignId => {
  const mutation = `
   mutation createCampaignDeliverability($input: CreateCampaignDeliverabilityInput!){
      createCampaignDeliverability(input: $input){
              id
              campaignId
              status
     }
  }
  `

  const variables = {
    input: {
      payload: { campaignId },
    },
  }

  return callAuthorizedGraphQLEndpoint(mutation, variables)
}

const getCampaignCityMetrics = async campaignId => {
  const query = `query($campaignId:ID)  {
          getCampaignCityMetrics (campaignId:$campaignId) {
              id
              campaignId
              cityId
              saverId
              totalFlyers
              totalMissions
              distributionCost
              travelCost
              permitCost
              printingCost
              bonusBudget
              postingCost
              dataCost
              outfitCost
              freightCost
              tax
              taxAmount
          }
      }`

  const response = await callAuthorizedGraphQLEndpoint(query, {
    campaignId,
  })
  const res = await response.json()
  const {
    data: { getCampaignCityMetrics },
  } = res
  return getCampaignCityMetrics
}

const updateCampaignCityMetrics = async ({ saverId, data, campaignId }) => {
  const query = `mutation updateCampaignCityMetrics($input: UpdateCampaignCityMetricsInput!){
    updateCampaignCityMetrics(input: $input){
      success
  }
}`
  const vars = {
    input: {
      campaignId,
      saverId,
      campaignCitiesMetrics: data,
    },
  }
  const response = await callAuthorizedGraphQLEndpoint(query, vars)
  const res = await response.json()

  return res
}

const updateCampaignTargeting = async ({ campaignId, data }) => {
  const query = `mutation updateCampaignTargeting($input: UpdateCampaignTargetingInput!){
    updateCampaignTargeting(input: $input){
      success
  }
}`
  const vars = {
    input: {
      campaignId,
      targeting: {
        type: data.targetType,
        gender: data.targetGender,
        income: data.targetIncome,
        ageGroups: data.targetAgeGroups,
        applyNiche: data.applyNicheTargeting,
        nicheDescription: data.nicheTargetingDescription,
      },
    },
  }
  const response = await callAuthorizedGraphQLEndpoint(query, vars)
  const res = await response.json()

  return res
}

const getCampaignMetricsTagsGQL = ({ type }) => {
  const sql = `
      query(
          $type: TagTypeEnum
      ){
            getTags(
                type: $type
            ){
                edges {
                   node {
                      id
                      value
                      type
                   }
                }
                totalCount
            }
      }
    `
  const params = { type }
  return callAuthorizedGraphQLEndpoint(sql, params)
}

const getCampaignShipments = async id => {
  const query = `query getCampaignShipment($input: GetCampaignShipment!) {
    getCampaignShipment(input: $input) {
      shipmentData
      shipmentDataRevision
    }
  }`

  const res = await callAuthorizedGraphQLEndpoint(query, {
    input: {
      // eslint-disable-next-line radix
      campaignId: parseInt(id),
    },
  })

  const {
    data: { getCampaignShipment },
  } = await res.json()

  return getCampaignShipment
}
const createCampaignShipments = async (id, data) => {
  const query = `mutation createCampaignShipment($input: CreateCampaignShipment!) {
    createCampaignShipment(input: $input) {
      success
    }
  }`

  const res = await callAuthorizedGraphQLEndpoint(query, {
    input: {
      campaignId: parseInt(id, 10),
      shipmentDataVersion: 1,
      shipmentData: data.map(d => ({
        ...d,
        amountSent: parseInt(d.amountSent, 10),
      })),
    },
  })

  const {
    data: { createCampaignShipment },
  } = await res.json()

  return createCampaignShipment
}

export {
  createCampaignDeliverabilityByCampaignId,
  getCampaignMetricsTagsGQL,
  getCampaignCityMetrics,
  updateCampaignCityMetrics,
  getCampaignShipments,
  createCampaignShipments,
  updateCampaignTargeting,
}
